// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://dev.api.irisgst.com/irisgst',
  uumUrl: 'https://dev.app.irisgst.com/logout-all-session',
  excelUtility:'https://gspbusinesslogo-backup.s3.ap-south-1.amazonaws.com/Onyx/IRIS_Onyx_v0.04_dev.zip',
  GA_TRACKING_ID: null,
  lmsUrl: 'https://dev.lms.irisgst.com'
  // apiUrl: '//13.232.74.147/irisgst/mgmt',
  // paymentURL: 'https://securegw-stage.paytm.in/order/process',
  // mockURL: 'https://276ba087-7722-4809-9f7c-77535216df1a.mock.pstmn.io',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
